import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { postInquiry } from "../lib/api";

const FIELD = "w-full bg-transparent border-b border-forest/20 focus:border-gold outline-none py-3 text-sm text-forest placeholder:text-forest/40 transition-colors";

export default function InquiryForm({ presetProduct = "", variant = "light" }) {
  const [form, setForm] = useState({
    name: "", email: "", company: "", country: "", phone: "",
    product: presetProduct, quantity: "", message: "",
  });
  const [loading, setLoading] = useState(false);
  const on = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill in name, email and message.");
      return;
    }
    setLoading(true);
    try {
      await postInquiry(form);
      toast.success("Inquiry received. Our export desk will respond within 24 hours.");
      setForm({ name: "", email: "", company: "", country: "", phone: "", product: presetProduct, quantity: "", message: "" });
    } catch {
      toast.error("Something went wrong. Please try again or WhatsApp us.");
    } finally {
      setLoading(false);
    }
  };

  const dark = variant === "dark";
  const fieldCls = dark
    ? FIELD.replace("border-forest/20", "border-beige/25").replace("text-forest", "text-beige").replace("placeholder:text-forest/40", "placeholder:text-beige/40")
    : FIELD;

  return (
    <form onSubmit={submit} data-testid="inquiry-form" className="grid sm:grid-cols-2 gap-6">
      <input data-testid="inq-name" className={fieldCls} placeholder="Full Name *" value={form.name} onChange={on("name")} />
      <input data-testid="inq-email" type="email" className={fieldCls} placeholder="Email *" value={form.email} onChange={on("email")} />
      <input data-testid="inq-company" className={fieldCls} placeholder="Company" value={form.company} onChange={on("company")} />
      <input data-testid="inq-country" className={fieldCls} placeholder="Country" value={form.country} onChange={on("country")} />
      <input data-testid="inq-phone" className={fieldCls} placeholder="Phone / WhatsApp" value={form.phone} onChange={on("phone")} />
      <input data-testid="inq-product" className={fieldCls} placeholder="Product of Interest" value={form.product} onChange={on("product")} />
      <input data-testid="inq-quantity" className={`${fieldCls} sm:col-span-2`} placeholder="Required Quantity (e.g. 5 MT)" value={form.quantity} onChange={on("quantity")} />
      <textarea data-testid="inq-message" rows={3} className={`${fieldCls} sm:col-span-2 resize-none`} placeholder="Your requirement / message *" value={form.message} onChange={on("message")} />
      <button
        data-testid="inq-submit" type="submit" disabled={loading}
        className={`sm:col-span-2 group flex items-center justify-center gap-3 py-4 text-sm uppercase tracking-widest font-medium transition-all duration-300 disabled:opacity-60 ${
          dark ? "bg-gold text-forest hover:bg-beige" : "bg-forest text-beige hover:bg-gold hover:text-forest"
        }`}
      >
        {loading ? "Sending…" : "Send Inquiry"}
        <Send className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
      </button>
    </form>
  );
}
